<ng-template #template>
  <aside [ngClass]="{
      'w-20': asideState.type === 'icons',
      'w-40': asideState.type === 'full'
    }" (mouseenter)="asideState.type = 'full'" (mouseleave)="asideState.type = 'icons'"
    class="group absolute pb-10 border-opacity-50 border-r-2 border-r-gray-700 hover:z-50 pl-2 hover:pl-0 xl:inline bg-bg2 h-screen transition-all overflow-y-scroll overflow-x-hidden hover:w-60 group-hover:w-60 z-50 hidden">
    <div class="h-16 flex justify-center items-center">
      <a [routerLink]="['/dashboard/inicio']" (click)="resetBookForm()">
      <div *ngIf="asideState.type === 'full'" class="relative top-0 bg-bg2 pb-1 pt-2 px-8 cursor-pointer z-50">
        <img class="w-24 animate-fade-in" src="assets/img/logo.svg" alt="Logo itevebasa" />
      </div>
      <div *ngIf="asideState.type === 'icons'" class="relative top-0 pb-2 pt-4 px-3 cursor-pointer z-50">
        <img (click)="resetBookForm()" class="w-10 animate-fade-in" src="assets/img/logo-min.svg"
          alt="Logo itevebasa mini" />
      </div>
    </a>
    </div>

    <div class="flex flex-col gap-1 mt-2 items-center group-hover:items-start">
      <ng-container *ngFor="let menu of menuItems">
        <app-aside-nav-item *ngIf="permissionCheck(menu)" [asideState]="asideState" [menuItem]="menu"
          class="sidebar transition-all duration-300 ease-in-out"></app-aside-nav-item>
      </ng-container>
    </div>

    <div class="w-full text-center mt-4" *ngIf="!isProfessional">
      <a (click)="resetBookForm()" routerLink="/dashboard/nueva-cita"
        class="bg-green2 text-green border border-green py-2 px-4 rounded-2xl">
        <span *ngIf="asideState.type === 'full'" class="truncate">Nueva cita</span>
        <span *ngIf="asideState.type === 'icons'">+</span>
      </a>
    </div>
    <div class="w-full text-center mt-4" *ngIf="isProfessional">
      <a (click)="resetBookForm()" routerLink="/"
        class="bg-green2 text-green border border-green py-2 px-4 rounded-2xl">
        <span *ngIf="asideState.type === 'full'" class="truncate">Nueva cita</span>
        <span *ngIf="asideState.type === 'icons'">+</span>
      </a>
    </div>

    <!--<div class="w-full text-center mt-8">
      <a routerLink="/dashboard/nueva-cita-profesionales" class="mt-12 bg-[#fffce6] text-yellow border border-yellow py-2 px-4 rounded-2xl">
        <span *ngIf="asideState.type === 'full'">Profesionales</span>
        <span *ngIf="asideState.type === 'icons'">+</span>
      </a>
    </div>-->
  </aside>

  <aside [ngClass]="{ hidden: !mobileMenuOpen }" class="absolute inset-0 z-40 hidden">
    <div id="menu-mask" class="absolute inset-0 mask" (click)="asideService.closeMobileMenu()"></div>
    <button class="text-black rounded-full bg-bg2 fixed right-2 top-2 z-20 p-2"
      (click)="asideService.closeMobileMenu()">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-8 stroke-black" viewBox="0 0 24 24" stroke-width="1.5"
        fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M18 6l-12 12" />
        <path d="M6 6l12 12" />
      </svg>
    </button>

    <div [@slideInOut]="menuState" id="menu-sidebar"
      class="absolute inset-0 overflow-y-auto top-0 left-0 bottom-0  max-w-fit bg-bg2 z-50 pb-16 pt-8 flex gap-4 flex-col">
      <ng-container *ngFor="let menu of menuItems">
        <app-aside-nav-item *ngIf="permissionCheck(menu)" [menuItem]="menu"
          [asideState]="{ type: 'full', collapsed: asideState.collapsed }"></app-aside-nav-item>
      </ng-container>
      <div class="w-full text-center mt-6" *ngIf="!isProfessional">
        <a (click)="resetBookForm()" routerLink="/dashboard/nueva-cita"
          class="bg-green2 text-green border border-green py-2 px-4 rounded-2xl truncate">
          <span *ngIf="asideState.type === 'full'">Nueva cita</span>
          <span *ngIf="asideState.type === 'icons'">+</span>
        </a>
      </div>
      <div id="" class="w-full text-center mt-6" *ngIf="isProfessional">
        <a (click)="resetBookForm()" routerLink="/dashboard/nueva-cita"
          class="bg-green2 text-green border border-green py-2 px-4 rounded-2xl truncate">
          <span *ngIf="asideState.type === 'full'">Nueva cita</span>
          <span *ngIf="asideState.type === 'icons'">+</span>
        </a>
      </div>
    </div>
  </aside>
</ng-template>